import { motion } from "framer-motion";
import { Sparkles, Loader2, Wand2, ArrowRight, ImagePlus } from "lucide-react";

/** Étape 2 : photo uploadée, avant génération IA — aperçu + CTA "AI Design Mode". */
export function PhotoIntro({ photo, aiLoading, onGenerate, onOpenPicker }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-6"
    >
      <div
        className="relative aspect-[16/10] rounded-3xl overflow-hidden border border-white/10 bg-[#0a0a0a]"
        data-testid="configurator-preview-initial"
      >
        <img
          src={photo}
          alt="Façade"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {aiLoading && (
          <div className="absolute inset-0 bg-black/75 backdrop-blur-sm flex flex-col items-center justify-center gap-4 z-10">
            <Loader2 size={48} className="animate-spin text-[#FF5A00]" />
            <div className="text-white font-display text-lg">
              Génération de 5 propositions IA…
            </div>
            <div className="text-neutral-400 text-sm">Patientez ≈ 45 secondes</div>
          </div>
        )}
        <div className="absolute top-4 left-4 bg-black/70 backdrop-blur text-white text-xs uppercase tracking-wider px-3 py-1.5 rounded-full">
          Photo originale
        </div>
        <button
          type="button"
          onClick={onOpenPicker}
          className="absolute top-4 right-4 bg-black/70 backdrop-blur text-white text-xs uppercase tracking-wider px-3 py-1.5 rounded-full hover:bg-black transition-colors flex items-center gap-1.5"
          data-testid="configurator-change-photo"
        >
          <ImagePlus size={12} /> Changer
        </button>
      </div>

      <div className="glass-strong rounded-3xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-5">
        <div className="w-12 h-12 rounded-full bg-[#FF5A00]/15 text-[#FF5A00] flex items-center justify-center shrink-0">
          <Sparkles size={20} />
        </div>
        <div className="flex-1">
          <h3 className="font-display text-xl md:text-2xl text-white mb-1">
            AI Design Mode
          </h3>
          <p className="text-sm text-neutral-400">
            L&apos;IA va générer <strong className="text-white">5 propositions</strong> :
            Classique · Pierre de Taille · Tout Brique · LED Architectural · Imitation Pierre Premium.
          </p>
        </div>
        <button
          type="button"
          onClick={onGenerate}
          disabled={aiLoading}
          data-testid="ai-generate-btn"
          className="btn-primary justify-center text-base px-6 py-3 disabled:opacity-50 w-full md:w-auto"
        >
          {aiLoading ? (
            <>
              <Loader2 size={18} className="animate-spin" /> Génération…
            </>
          ) : (
            <>
              <Wand2 size={18} /> Créer 5 propositions
              <ArrowRight size={16} />
            </>
          )}
        </button>
      </div>
    </motion.div>
  );
}
